import { useSnackbar } from "notistack";
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControl,
} from "@mui/material";
import {useEffect, useState} from "react";
import * as React from 'react';
import DialogActions from '@mui/material/DialogActions';
import DialogContentText from '@mui/material/DialogContentText';
import * as XLSX from 'xlsx';
import sendRequest from "../services/sendRequest";
import MoonLoader from "react-spinners/MoonLoader";
import DownloadIcon from "@mui/icons-material/Download"; // Import
import { IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const ExchangeRatesUpload =({open, close, selected, setRefresh}) => {
const [items, setItems] = useState([]);
const [formData, setFormData] = useState({});
const { enqueueSnackbar, closeSnackbar } = useSnackbar()
const [fullWidth, setFullWidth] = React.useState(true);
const [maxWidth, setMaxWidth] = React.useState('sm');
let [loading, setLoading] = useState(false);
let [color, setColor] = useState("#000000");
const page ="exchange_rates";
const override = {
  display: "block",
  margin: "0 auto",
  borderColor: "red",
};
const handleClose = () => {
    close();
  };

  useEffect(() => {
  });

  // handle file upload
  const handleFileUpload = e => {
    let isValidRow = true;
    let isColumnsMissing = true;
    let isValideCurreny = true;
    setLoading(true)
    const file = e.target.files[0];
    const reader = new FileReader();
    reader.onload = async (evt) => {
      /* Parse data */
      const bstr = evt.target.result;
      const wb = XLSX.read(bstr, { type: 'binary' });
      /* Get first worksheet */
      const wsname = wb.SheetNames[0];
      const ws = wb.Sheets[wsname];
      /* Convert array of arrays */
      const Papa = require('papaparse');
      const fileData = XLSX.utils.sheet_to_csv(ws, { header: 1 });

      // Parse the CSV data
      const parsedData = Papa.parse(fileData, {
        header: false, // Set to true if the first row contains headers
      });

      // Initialize an array to hold column-wise data
      let columns = [];
      const items = [];

      // Iterate through each row
      parsedData.data.forEach((row, rowIndex) => {
        // Iterate through each cell and organize them into columns
        if (row.length != 3) {
          isValidRow = false;
        }
        row.forEach((cell, colIndex) => {
          // Initialize the column array if it doesn't exist
          if (!columns[colIndex]) {
            columns[colIndex] = [];
          }
          // Add the cell to the appropriate column
          columns[colIndex][rowIndex] = cell;
        });
        // Create an object for each row
        if (row[0] === "" && row[1] === "" && row[2] === "") {
          // All values are empty, do nothing
        } else if (row[0] === "" || row[1] === "" || row[2] === "") {
          isColumnsMissing = true;
          isValidRow = false;
        } else {
          if (/^[A-Z]{3}$/.test(row[0])) {
            const newObject = {
              currency: row[0],
              date: row[1],
              rate: row[2],
            };
            items.push(newObject);
          } else {
            isValidRow = false;
            isValideCurreny = true;
            isColumnsMissing = false;
          }
        }        
      });
      console.log(items);
      if (isValidRow) {
        try {      
          const response = await sendRequest({
            requestType: "post",
            endpoint: `${page}/custom_bulk_create/`,
            requestData: items,
          });
      
          if (response.status === 200) {
            setItems([]);
            if(response && response.data && response.data.er_list) {
              localStorage.setItem('bulk_exchange_rates',JSON.stringify(response.data.er_list));
            }
            handleAllTypesOfMessages(response.data.message, 'success');
            handleClose();
          } else {
            handleAllTypesOfMessages('There is an Error with the file, Please Check the .csv file and Reupload it!', 'error');
          }
      
        } catch (error) {
          console.error("An error occurred:", error);
          handleAllTypesOfMessages('There is an Error with the file, Please Check the .csv file and Reupload it!', 'error');
        } finally {
          setItems([]);
          setLoading(false);
          handleClose();
        }
      } else {
        if(isColumnsMissing) {
          setItems([]);
          handleAllTypesOfMessages('Some of the exchange rate records have empty details. Please fill them in and re-upload the file', 'warning');
          setLoading(false)
          handleClose();
        } else if(isValideCurreny) {
          setItems([]);
          handleAllTypesOfMessages('Invalid value in Currency. It should contain exactly 3 capital letters', 'warning');
          setLoading(false)
          handleClose();
        } else {
          setItems([]);
          handleAllTypesOfMessages('Ensure that the file contains only these 3 Columns [Currency, Date of entry, Exchange Rate] in the specified order and does not include any headers', 'warning');
          setLoading(false)
          handleClose();
        }        
      }
    };
    reader.readAsBinaryString(file);
  }



  const handleDownloadBulkTemplateForExchangeRates = () => {
  // Define the data
  const headers = ["Currency", "Date of entry(MM/DD/YYYY)", "Exchange Rate"];
  const rows = [
    ["AUD", "1/1/2026", "1.6133"],
    ["GBP", "1/1/2026", "0.8048"],
    ["EUR", "1/1/2026", "0.9655"],
    ["NZD", "1/1/2026", "1.7797"],
    ["AUD", "2/1/2026", "1.6142"],
    ["GBP", "2/1/2026", "0.7942"],
    ["EUR", "2/1/2026", "0.9615"],
    ["NZD", "2/1/2026", "1.7911"],
  ];

  // Combine headers and rows
  const data = [headers, ...rows];

  // Create a workbook and worksheet
  const workbook = XLSX.utils.book_new();
  const worksheet = XLSX.utils.aoa_to_sheet(data);
  XLSX.utils.book_append_sheet(workbook, worksheet, "Exchange Rates");

  // Set column widths dynamically based on the maximum content length in each column
  const columnWidths = headers.map((_, colIndex) => {
    const maxLength = Math.max(
      ...data.map((row) => (row[colIndex] ? row[colIndex].toString().length : 0))
    );
    return { wch: maxLength + 5 }; // Add padding for readability
  });
  worksheet["!cols"] = columnWidths;

  // Export the workbook as a CSV file
  XLSX.writeFile(workbook, "Exchange_Rates_Bulk.csv");
};

  //handleAllTypesOfMessages
  // const handleAllTypesOfMessages = (message, type) => {
  //   enqueueSnackbar(message, {
  //     variant: type,
  //   });
  // };

  //handleAllTypesOfMessages
  const handleAllTypesOfMessages = (message, type) => {
    const action = (key) => (
      <IconButton
        aria-label="close"
        color="inherit"
        onClick={() => closeSnackbar(key)}
      >
        <CloseIcon />
      </IconButton>
    );

    enqueueSnackbar(message, {
      variant: type,
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'left',
      },
      persist: true, // <- keeps the snackbar visible until manually closed
      // autoHideDuration: 20000,
      action
    });
  };

  return (
    <Dialog
    open={open}
    onClose={() => {
      close();
    }}
    >
      <DialogContent>
        <Dialog
            fullWidth={fullWidth}
            maxWidth={maxWidth}
            open={open}
            onClose={handleClose}
          >
            <MoonLoader
              color={color}
              loading={loading}
              cssOverride={override}
              size={40}
              aria-label="Loading Spinner"
              data-testid="loader"
            />
            <DialogTitle sx={{ textAlign: 'center' }}>Upload CSV</DialogTitle>
            <DialogContent sx={{ marginBottom: 2 }}>
              <DialogContentText sx={{ textAlign: 'center' , whiteSpace: 'normal', wordWrap: 'break-word', marginBottom: 2}}>
              Upload a CSV file to Create the new Exchange Rates!
              <Button
                variant="contained"
                color="primary"
                startIcon={<DownloadIcon />}
                onClick={handleDownloadBulkTemplateForExchangeRates}
              >                
              </Button>
              </DialogContentText>
              <DialogContentText sx={{ textAlign: 'center' , whiteSpace: 'normal', wordWrap: 'break-word', marginBottom: 2}}>
              <b>The .CSV file with no headers should contain the following columns in the specified order: 1) Currency, 2) Date of entry(MM/DD/YYYY), 3) Exchange Rate.</b>
              </DialogContentText>
              <DialogContentText sx={{ textAlign: 'center' , whiteSpace: 'normal', wordWrap: 'break-word', marginBottom: 2}}>
                <b>A download option is available above to access a sample template for reference before uploading your file. The template file contains the headers as well, but please ensure to remove the headers before uploading.</b>
              </DialogContentText>
              <Box
                noValidate
                component="form"
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  m: 'auto',
                  width: 'fit-content',
                }}
              >        
              <FormControl sx={{ mt: 2, minWidth: 120 }}>              
                <input type="file" accept=".csv,.xlsx,.xls" onChange={handleFileUpload}/>
              </FormControl>
              </Box>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleClose}>Close</Button>
            </DialogActions>
          </Dialog>
      </DialogContent>
    </Dialog>
  );
};

export default ExchangeRatesUpload;
